import {
  FLOW_TYPES,
  REQUEST_STATUS,
  REQUEST_TYPES,
} from './constants';

const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

export const MOCK_DEPARTMENTS = [
  { value: 'engineering', label: 'Engineering' },
  { value: 'product', label: 'Product' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hr', label: 'HR' },
];

export const MOCK_LIVE_JOBS = [
  { value: 'job-1', label: 'UX Designer — Remote' },
  { value: 'job-2', label: 'Frontend Lead — London' },
  { value: 'job-3', label: 'Senior Backend Engineer — Hybrid' },
];

export const MOCK_APPROVAL_TEMPLATES = [
  { value: 'standard-hire', label: 'Standard Hire' },
  { value: 'senior-hire', label: 'Senior Hire (>$80k)' },
  { value: 'campaign-default', label: 'Campaign Default' },
  { value: 'custom', label: 'Build your own' },
];

export const MOCK_APPROVERS_POOL = [
  {
    value: 'ms',
    label: 'Marc Smith — Hiring Manager',
    name: 'Marc Smith',
    role: 'Hiring Manager',
    email: 'marc.smith@company.com',
  },
  {
    value: 'lb',
    label: 'Lisa Brown — HR Director',
    name: 'Lisa Brown',
    role: 'HR Director',
    email: 'lisa.brown@company.com',
  },
  {
    value: 'ar',
    label: 'Alex Rivera — Marketing Lead',
    name: 'Alex Rivera',
    role: 'Marketing Lead',
    email: 'alex.rivera@company.com',
  },
  {
    value: 'jk',
    label: 'Jane Kim — Finance',
    name: 'Jane Kim',
    role: 'Finance',
    email: 'jane.kim@company.com',
  },
];

export const MOCK_PROMOTION_CHANNELS = [
  {
    id: 'careers',
    name: 'Careers Page',
    badge: 'Free',
    badgeVariant: 'free',
    description: 'Owned channel • No cost',
  },
  {
    id: 'linkedin-free',
    name: 'LinkedIn Free Post',
    badge: 'Free',
    badgeVariant: 'free',
    description: 'Social • Organic reach',
  },
  {
    id: 'linkedin-premium',
    name: 'LinkedIn Premium Job',
    badge: 'Paid',
    badgeVariant: 'paid',
    description: 'Job boards • £199 / 28d',
  },
  {
    id: 'indeed-sponsored',
    name: 'Indeed Sponsored',
    badge: 'Paid',
    badgeVariant: 'paid',
    description: 'Job boards • £150 / 14d',
  },
  {
    id: 'internal',
    name: 'Internal Referral Boost',
    badge: 'Internal',
    badgeVariant: 'internal',
    description: 'Employee network • £0',
  },
];

export const MOCK_APPROVAL_CHAINS = [
  {
    id: 'chain-1',
    type: REQUEST_TYPES.HIRE,
    title: 'Standard Hire',
    rolesSummary: 'Hiring Manager → HR Director',
    flowType: FLOW_TYPES.SEQUENTIAL,
    approvers: [
      { name: 'Marc Smith', role: 'Hiring Manager' },
      { name: 'Lisa Brown', role: 'HR Director' },
    ],
  },
  {
    id: 'chain-2',
    type: REQUEST_TYPES.HIRE,
    title: 'Senior Hire (>$80k)',
    rolesSummary: 'Hiring Manager → HR Director → Finance',
    flowType: FLOW_TYPES.SEQUENTIAL,
    approvers: [
      { name: 'Marc Smith', role: 'Hiring Manager' },
      { name: 'Lisa Brown', role: 'HR Director' },
      { name: 'Jane Kim', role: 'Finance' },
    ],
  },
  {
    id: 'chain-3',
    type: REQUEST_TYPES.CAMPAIGN,
    title: 'Parallel Sign-off',
    rolesSummary: 'Hiring Manager + Marketing Lead',
    flowType: FLOW_TYPES.PARALLEL,
    approvers: [
      { name: 'Marc Smith', role: 'Hiring Manager' },
      { name: 'Alex Rivera', role: 'Marketing Lead' },
    ],
  },
];

export const MOCK_REQUESTS = [
  {
    id: 'req-1',
    type: REQUEST_TYPES.HIRE,
    title: 'Senior Backend Engineer',
    status: REQUEST_STATUS.WITHDRAWN,
    department: 'Engineering',
    location: 'London',
    positions: 2,
    salaryRange: '£85,000 - £105,000',
    flowType: FLOW_TYPES.SEQUENTIAL,
    note: 'Team expansion to support new product launch',
    requestedBy: { id: 'user-1', name: 'Sarah Chen' },
    createdAt: daysAgo(7),
    approvedCount: 1,
    totalApprovers: 4,
    approvers: [
      {
        userId: 'ms',
        name: 'Marc Smith',
        role: 'Hiring Manager',
        status: 'approved',
        order: 1,
      },
      {
        userId: 'lb',
        name: 'Lisa Brown',
        role: 'HR Director',
        status: 'pending',
        order: 2,
      },
      {
        userId: 'jk',
        name: 'Jane Kim',
        role: 'Finance',
        status: 'upcoming',
        order: 3,
      },
      {
        userId: 'ar',
        name: 'Alex Rivera',
        role: 'VP Engineering',
        status: 'upcoming',
        order: 4,
      },
    ],
    reason: 'Backfill for departing engineer',
    justification: 'Critical path delivery depends on this hire.',
  },
  {
    id: 'req-2',
    type: REQUEST_TYPES.CAMPAIGN,
    title: 'Campaign boost — Frontend Lead',
    status: REQUEST_STATUS.PENDING,
    jobTitle: 'Frontend Lead',
    budget: '£2,500',
    durationDays: 21,
    channels: ['LinkedIn Premium Job', 'Indeed Sponsored'],
    flowType: FLOW_TYPES.PARALLEL,
    note: 'Applications stalled — need paid promotion to widen reach',
    requestedBy: { id: 'user-2', name: 'Alex Rivera' },
    createdAt: daysAgo(7),
    approvedCount: 0,
    totalApprovers: 2,
    approvers: [
      {
        userId: 'ar',
        name: 'Alex Rivera',
        role: 'Marketing Lead',
        status: 'awaiting',
        order: 1,
        email: 'alex.rivera@company.com',
      },
      {
        userId: 'ms',
        name: 'Marc Smith',
        role: 'Hiring Manager',
        status: 'awaiting',
        order: 2,
        email: 'marc.smith@company.com',
      },
    ],
    reason: 'Applications stalled — need paid promotion to widen reach',
    justification:
      'Organic reach has plateaued. Sponsored channels should increase applicant volume within two weeks.',
    rejectionNote: 'Re-submit with a lower budget',
    auditLog: [
      {
        id: 'log-1',
        actor: 'Alex Rivera',
        action: 'submitted campaign approval request',
        timestamp: daysAgo(7),
      },
    ],
  },
  {
    id: 'req-3',
    type: REQUEST_TYPES.HIRE,
    title: 'Product Designer',
    status: REQUEST_STATUS.PENDING,
    department: 'Product',
    location: 'Remote (UK)',
    positions: 1,
    salaryRange: '£55,000 - £65,000',
    flowType: FLOW_TYPES.SEQUENTIAL,
    note: 'New design capacity for Q3 roadmap',
    requestedBy: { id: 'current-user', name: 'You' },
    createdAt: daysAgo(2),
    approvedCount: 0,
    totalApprovers: 2,
    approvers: [
      {
        userId: 'current-user',
        name: 'You',
        role: 'Requester',
        status: 'upcoming',
        order: 0,
      },
      {
        userId: 'ms',
        name: 'Marc Smith',
        role: 'Hiring Manager',
        status: 'awaiting',
        order: 1,
      },
      {
        userId: 'lb',
        name: 'Lisa Brown',
        role: 'HR Director',
        status: 'upcoming',
        order: 2,
      },
    ],
    reason: 'Design backlog exceeds current team capacity',
    justification: '',
  },
  {
    id: 'req-4',
    type: REQUEST_TYPES.HIRE,
    title: 'Senior Data Analyst',
    status: REQUEST_STATUS.PENDING,
    department: 'Data & Insights',
    location: 'London (Hybrid)',
    positions: 1,
    salaryRange: '£70,000 - £80,000',
    flowType: FLOW_TYPES.SEQUENTIAL,
    note: 'New analytics capacity for customer insights programme',
    requestedBy: { id: 'user-4', name: 'Priya Patel' },
    createdAt: daysAgo(1),
    approvedCount: 1,
    totalApprovers: 3,
    approvers: [
      {
        userId: 'ms',
        name: 'Marc Smith',
        role: 'Hiring Manager',
        status: 'approved',
        order: 1,
        email: 'marc.smith@company.com',
        comment: 'Strongly supported — critical hire for Q3.',
        actedAt: daysAgo(0.3),
      },
      {
        userId: 'current-user',
        name: 'You',
        role: 'Department Head',
        status: 'awaiting',
        order: 2,
        email: 'you@company.com',
      },
      {
        userId: 'jk',
        name: 'Tom Hardy',
        role: 'Finance Director',
        status: 'upcoming',
        order: 3,
        email: 'tom.hardy@company.com',
      },
    ],
    reason: 'Expand analytics team',
    justification: 'Required for the customer insights roadmap.',
    outOfOfficeNotice:
      'Tom Hardy is out of office until Sun 7 Jun — Sarah Chen (Department Head) has been notified to keep an eye on this approval.',
    auditLog: [
      {
        id: 'log-sda-1',
        actor: 'System',
        action: 'notified Marc Smith (step 1)',
        timestamp: daysAgo(1),
      },
      {
        id: 'log-sda-2',
        actor: 'Marc Smith',
        action: 'approved',
        note: 'Strongly supported — critical hire for Q3.',
        timestamp: daysAgo(0.3),
      },
      {
        id: 'log-sda-3',
        actor: 'Priya Patel',
        action: 'submitted hire approval request',
        timestamp: daysAgo(1),
      },
    ],
  },
  {
    id: 'req-5',
    type: REQUEST_TYPES.HIRE,
    title: 'Product Designer (Mid-level)',
    status: REQUEST_STATUS.REJECTED,
    department: 'Design',
    location: 'Manchester',
    positions: 1,
    salaryRange: '£65,000 - £75,000',
    flowType: FLOW_TYPES.SEQUENTIAL,
    note: 'Backfill following resignation in Q1',
    requestedBy: { id: 'current-user', name: 'Morgan Russell' },
    createdAt: daysAgo(10),
    approvedCount: 2,
    totalApprovers: 4,
    approvers: [
      {
        userId: 'ms',
        name: 'Marc Smith',
        role: 'Hiring Manager',
        status: 'approved',
        order: 1,
        email: 'marc.smith@company.com',
        comment: 'Backfill is justified — proceed.',
        actedAt: daysAgo(3),
      },
      {
        userId: 'lb',
        name: 'Sarah Chen',
        role: 'Department Head',
        status: 'approved',
        order: 2,
        email: 'sarah.chen@company.com',
        comment: 'Agreed on scope.',
        actedAt: daysAgo(2),
      },
      {
        userId: 'jk',
        name: 'Tom Hardy',
        role: 'Finance Director',
        status: 'rejected',
        order: 3,
        email: 'tom.hardy@company.com',
        comment:
          'Budget band is above the approved Q2 plan for Design. Please resubmit at £55-65k or attach a re-forecast.',
        actedAt: daysAgo(1),
      },
      {
        userId: 'ceo',
        name: 'Nina Park',
        role: 'CEO',
        status: 'upcoming',
        order: 4,
        email: 'nina.park@company.com',
      },
    ],
    reason: 'Backfill following resignation in Q1',
    justification:
      'Replacing Jane Doe who left in February. Same scope and band as the outgoing role.',
    auditLog: [
      {
        id: 'log-pd-1',
        actor: 'Tom Hardy',
        action: 'rejected',
        note: 'Budget band is above the approved Q2 plan for Design. Please resubmit at £55-65k or attach a re-forecast.',
        timestamp: daysAgo(1),
      },
      {
        id: 'log-pd-2',
        actor: 'Sarah Chen',
        action: 'approved',
        note: 'Agreed on scope.',
        timestamp: daysAgo(2),
      },
      {
        id: 'log-pd-3',
        actor: 'Marc Smith',
        action: 'approved',
        note: 'Backfill is justified — proceed.',
        timestamp: daysAgo(3),
      },
      {
        id: 'log-pd-4',
        actor: 'Morgan Russell',
        action: 'submitted hire approval request',
        timestamp: daysAgo(10),
      },
    ],
  },
];
